import React, { useState } from 'react';
import { CircularProgress, Container } from '@mui/material';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { NivoBarChart } from './charts/nivo/Bar';
import { NivoLineChart } from './charts/nivo/Line';
import { TableChart } from './charts/sheet/Table';
import { chartData, chartGroup, filterForChart } from './states/Chart';

import useStyles from './styles';

const ChartGroups = ({ name }) => {
  const charts = useRecoilValue(chartGroup(name));
  return (
    <div>
      {charts.map((chart) => (
        <ChartContainer config={chart} key={chart.id} />
      ))}
    </div>
  );
};

const ChartContainer = ({ config }) => {
  const { classes } = useStyles();
  const setFilter = useSetRecoilState(filterForChart(config.id));
  if (config.attributes) {
    const { start, end } = config.attributes;
    let updated = {};
    if (start) {
      updated['start'] = moment().add(parseInt(start.split(' ')[0], 10), start.split(' ')[1]);
    }
    if (end) {
      updated['end'] = moment().add(parseInt(end.split(' ')[0], 10), end.split(' ')[1]);
    }
    setFilter((filter) => ({ ...filter, ...updated }));
  }

  return (
    <div className={classes.chartContainer}>
      <div className={classes.chartName}>{config.name}</div>
      <div>
        <ChartFilterConatiner config={config} />
      </div>
      <Chart config={config} />
    </div>
  );
};

const ChartFilterConatiner = ({ config }) => {
  const [filter, setFilter] = useRecoilState(filterForChart(config.id));
  return <div></div>;
};

const Chart = ({ config }) => {
  const [selectedView, changeSelected] = useState(0);
  const view = config.views[selectedView];
  const data = useRecoilValue(chartData(config.id));
  const { classes } = useStyles();
  return (
    <div>
      {config.views.length < 2 ? (
        <div></div>
      ) : (
        <div style={{ marginBottom: 10 }}>
          {config.views.map((v, i) => (
            <span key={`view-${i}`} onClick={() => changeSelected(i)} className={classes.viewName} style={{ backgroundColor: i === selectedView ? '#eee' : '#fff' }}>
              {v.name}
            </span>
          ))}
        </div>
      )}
      <CharView view={view} data={data} />
    </div>
  );
};

const CharView = ({ view, data }) => {
  const { classes } = useStyles();
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <div
        className={classes.chartView}
        style={{
          width: view.config.width,
          height: view.config.height,
          minWidth: 600,
          minHeight: 300,
        }}
      >
        {view.graphic_type === 'nivo' && view.chart_type === 'ResponsiveLine' && <NivoLineChart view={view} data={data} />}
        {view.graphic_type === 'nivo' && view.chart_type === 'ResponsiveBar' && <NivoBarChart view={view} data={data} />}
        {view.graphic_type === 'sheet' && view.chart_type === 'table' && <TableChart view={view} data={data} />}
      </div>
    </React.Suspense>
  );
};

export default function ProjectionsContainer(props) {
  const { name } = useParams();
  return (
    <Container maxWidth="lg">
      <h4>Volume Projections</h4>
      <React.Suspense fallback={<CircularProgress />}>
        <ChartGroups name={name} />
      </React.Suspense>
    </Container>
  );
}
